import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoPopupComponent } from './components/video-popup/video-popup.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { VideoModule } from '../video/video.module';
import { TranslateModule } from '@ngx-translate/core';
import { TestToggleComponent } from './components/test-toggle/test-toggle.component';
import { ToolComponent } from './components/tool/tools.component';
import { HintPopupComponent } from './components/hint-popup/hint-popup.component';
import { CarouselModule } from '../carousel/carousel.module';
import { RubricPopupComponent } from './components/rubric-popup/rubric-popup.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { VerbalPromptButtonComponent } from '../footer/components/verbal-prompt-button/verbal-prompt-button.component';
import { VerbalHintsButtonComponent } from '../footer/components/verbal-hints-button/verbal-hints-button.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    VideoModule,
    TranslateModule,
    CarouselModule,
    NgxSkeletonLoaderModule,
  ],
  declarations: [
    ToolComponent,
    VideoPopupComponent,
    TestToggleComponent,
    HintPopupComponent,
    RubricPopupComponent,
    VerbalPromptButtonComponent,
    VerbalHintsButtonComponent,
  ],
  exports: [
    ToolComponent,
    VideoPopupComponent,
    TestToggleComponent,
    HintPopupComponent,
    RubricPopupComponent,
    VerbalPromptButtonComponent,
    VerbalHintsButtonComponent,
  ],
})
export class ToolsModule {}
